import { useEffect } from 'react';
import PageLayout from '../../Containers/PageLayout';
import {
  setPreviewShiftDetails,
  setStartOrderData,
} from '../../redux/commonSlice';
import PreviewShift from './PreviewShift';
import StartOrder from './StartOrder';
import './order.scss';
import { useDispatch } from 'react-redux';
import { setQuantity, setShifts } from '../../redux/orderSlice';
import { setSchdulesTypes } from '../../redux/riskCenterSlice';

interface Props {
  page: string;
}

const Order = (props: Props) => {
  const { page } = props;
  const dispatch = useDispatch();
  useEffect(() => {
    return () => {
      dispatch(setStartOrderData({}));
      dispatch(setShifts(''));
      dispatch(setQuantity(''));
      dispatch(setSchdulesTypes({}));
      dispatch(setPreviewShiftDetails({}));
    };
  }, []);

  return (
    <PageLayout>
      <div>
        {page === 'orders' ? (
          <StartOrder />
        ) : page === 'preview-shift' ? (
          <PreviewShift />
        ) : (
          <p>null</p>
        )}
      </div>
    </PageLayout>
  );
};

export default Order;
